/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'CategoryCubes': {
    width: 11,
    height: 10,
    viewBox: '0 0 11 10',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M2.051.29h1.592A1.2 1.2 0 014.84 1.496v1.606c0 .669-.533 1.206-1.197 1.206H2.051A1.2 1.2 0 01.855 3.102V1.496C.855.831 1.392.29 2.05.29zm0 5.402h1.592c.664 0 1.197.538 1.197 1.206v1.606A1.2 1.2 0 013.643 9.71H2.051c-.66 0-1.196-.542-1.196-1.206V6.898A1.2 1.2 0 012.05 5.692zM9.08.29H7.487A1.2 1.2 0 006.29 1.496v1.606c0 .669.532 1.206 1.196 1.206h1.592a1.2 1.2 0 001.196-1.206V1.496C10.275.831 9.738.29 9.08.29zM7.487 5.692h1.592a1.2 1.2 0 011.196 1.206v1.606c0 .664-.537 1.206-1.196 1.206H7.487A1.2 1.2 0 016.29 8.504V6.898c0-.668.532-1.206 1.196-1.206z" _fill="#00204D" fill-opacity=".5"/>'
  }
})
